import { FormGroup } from 'reactstrap'
import { ErrorFeedback } from 'common-components/view-logic'
import { RadioButtonGroup } from 'common-components'

const PolicyOwnerSelection = ({ policyownerOptions, policyowner, errors, validateSelectPolicyOwner }) => (
  <FormGroup id="policy-owner-selection" className={`${errors.length > 0 ? 'has-danger' : ''}`}>
    <div className="options option-labels">
      <label>ท่านต้องการสมัครผลิตภัณฑ์ Super 7 CriticalCare ให้กับ</label>
    </div>
    <div className="options option-inputs">
      <div className="form-group">
        <div className="input">
          <RadioButtonGroup
            value={policyowner}
            options={policyownerOptions}
            onChange={validateSelectPolicyOwner}
            classNamePrefix="gender"
            autoClassName={true}
          />
          <ErrorFeedback
            id={'select-policy-owner-info'}
            errorMessages={['บริษัทฯ จะพิจารณารับประกันเฉพาะบุคคลที่มีสัญชาติไทยเท่านั้น']}
            messageType={'info-message'}
          />
          <ErrorFeedback id={'select-policy-owner-info'} errorMessages={[errors]} messageType={'error-message'} />
          {/* <FormFeedback className="validation-message">{errors}</FormFeedback> */}
        </div>
      </div>
    </div>
  </FormGroup>
)

export default PolicyOwnerSelection
